import React from 'react';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import { Security as SecurityIcon } from '@mui/icons-material';

const SessionExpiredMessage: React.FC = () => {
  const handleSignIn = () => {
    // Clear any stale state and redirect to home to trigger login
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          p: 3
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 2,
            width: '100%'
          }}
        >
          <SecurityIcon 
            sx={{ 
              fontSize: 64, 
              color: 'warning.main', 
              mb: 2 
            }} 
          />
          
          <Typography variant="h4" gutterBottom color="warning.main">
            Session Expired
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your session has expired. Please sign in again to continue.
          </Typography>

          <Button
            variant="contained"
            onClick={handleSignIn}
            sx={{ minWidth: 120 }}
          >
            Sign In Again
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default SessionExpiredMessage;
